var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheHomeSlider'),_c('ThePrinters'),_c('TheMedia',{attrs:{"data-aos":"fade-up","data-aos-duration":"1500"}}),_c('TheAccessories')],1)}
var staticRenderFns = []

export { render, staticRenderFns }